import {normalize, schema} from 'normalizr';

export default {
    getDapanList() {
        // 开盘中
        this.$api.getDapan().then(res => {
            // console.log("获取大盘信息", res);
            if (res.data.code === 1) {
                const patronsSchema = new schema.Entity('patrons', undefined, {
                    idAttribute: 'symbol'
                });
                const newdata = normalize(res.data.data, [patronsSchema]);
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: newdata, b: 0
                });
                // 开盘中，递归获取大盘信息
                if (this.isopen) {
                    setTimeout(() => {
                        this.getDapanList();
                    }, this.$globle.upDpTime)
                }
            }
        });
    },
    /**
     * 获取自选列表
     */
    getZixuanList() {
        this.$api.mychoosestock(this.token, this.userName).then(res => {
            if (res.data.code === 200) {
                if (res.data.data.hasOwnProperty('status') && res.data.data.status === 400) {
                    return false;
                }
                const patronsSchema = new schema.Entity('patrons', undefined, {
                    idAttribute: 'symbol'
                });
                const newdata = normalize(res.data.data, [patronsSchema]);
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: newdata, b: 5
                });
            } else {
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: null, b: 5
                });
            }
        });
    },

    /**
     * 更新所有板块
     */
    getAllGupiao() {
        const gupiaolist_sz = sessionStorage.getItem('gupiaolist_sz');
        const gupiaolist_zx = sessionStorage.getItem('gupiaolist_zx');
        const gupiaolist_cy = sessionStorage.getItem('gupiaolist_cy');
        const gupiaolist_kc = sessionStorage.getItem('gupiaolist_kc');
        const gupiaolist_time = sessionStorage.getItem('gupiaolist_time');
        // 没有缓存上次时间，新获取
        if (!gupiaolist_time) {
            // 循环获取3板股票
            this.updataAllGupiao();
        } else {
            const time_ = (new Date()).getTime() - (+gupiaolist_time);
            if (time_ > 86400000 || (new Date()).getDate() !== (new Date(+gupiaolist_time)).getDate()) {
                // 超过一天，或者日期不是同一天，从新循环获取3板股票
                this.updataAllGupiao();
            } else if (!gupiaolist_sz || !gupiaolist_cy || !gupiaolist_zx || gupiaolist_kc) {
                // 4板股票列表不全，从新循环获取4板股票
                this.updataAllGupiao();
            } else {
                // 缓存的正常, 全局设置
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: JSON.parse(gupiaolist_sz), b: 1
                });
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: JSON.parse(gupiaolist_zx), b: 2
                });
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: JSON.parse(gupiaolist_cy), b: 3
                });
                this.$store.commit('SET_GUPIAO_LIST', {
                    a: JSON.parse(gupiaolist_kc), b: 4
                });
            }
        }
    },
    updataAllGupiao() {
        let cyzx = [];
        [2, 3, 4, 1].map(i => {
            this.$api.getGpList(i).then(res => {
                if (i === 2) {
                    console.log("中小板代码列表", res);
                }
                if (i === 3) {
                    console.log("创业板代码列表", res);
                }
                if (res.data.code === 1) {
                    if (i === 1) {
                        cyzx = res.data.data.concat(cyzx);
                    } else {
                        cyzx = cyzx.concat(res.data.data);
                    }
                    const patronsSchema = new schema.Entity('patrons', undefined, {
                        idAttribute: 'code'
                    });
                    const newdata = normalize(i === 1 ? cyzx : res.data.data, [patronsSchema]);
                    this.$store.commit('SET_GUPIAO_LIST', {
                        a: newdata, b: i
                    });
                    sessionStorage.setItem(this.bkNamess[i - 1], JSON.stringify(newdata));
                    sessionStorage.setItem('gupiaolist_time', JSON.stringify((new Date()).getTime()));
                }
            });
        })
    }
}
